<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>{{ baixa ? 'Baixar' : item.id > 0 ? 'Editar' : 'Novo'}} Compromisso</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" v-if="item.situacao != 'P'" :disabled="!valid">{{ baixa ? 'Baixar' : 'Salvar'}}</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroCompromisso" ref="formCadastroCompromisso" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.id" label="Documento" disabled dense outlined/>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-select v-model="item.planoContaId" label="Plano de Contas" :items="planoContas" item-value="id" item-text="descricao" :rules="fieldRules" :disabled="baixa" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-select v-model="item.planoContaItemId" label="Plano de Contas (Item)" :items="planoContaItens.filter(x => x.ativo == true || (x.ativo == false && x.id == item.planoContaItemId))" item-value="id" item-text="descricao" :rules="fieldRules" :disabled="baixa" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-text-field v-model="item.descricao" label="Descrição" :rules="fieldRules" :disabled="baixa" :counter="60" maxlength="60" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete v-model="item.bancoId" :items="bancos" item-text="codigoNome" item-value="id" label="Banco" :rules="fieldRules" dense outlined/>
                            <!-- <v-select v-model="item.bancoId" label="Banco" :items="bancos" item-value="id" item-text="nome" :rules="fieldRules" dense outlined/> -->
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-autocomplete v-model="item.fornecedorId" :items="fornecedores" :loading="isFornecedorLoading" :search-input.sync="searchFornecedor" hide-no-data hide-selected cache-items clearable
                                item-text="cpfCnpjNome" item-value="id" label="Fornecedor" :placeholder="item.fornecedor ? item.fornecedor.cpfCnpjNome : 'Digite um fornecedor'" :rules="fieldRules" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                          <v-autocomplete v-model="item.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected clearable
                              item-text="codigoNome" item-value="id" label="Projeto" :placeholder="item.projeto ? item.projeto.codigoNome : 'Digite um projeto'" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="item.atividadeId" label="Atividade" :items="atividades" item-value="id" item-text="nome" :rules="fieldRules" :disabled="baixa" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="item.atividadeItemId" label="SubAtividade" :items="atividadeItens" item-value="id" item-text="nome" :rules="fieldRules" :disabled="baixa" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataLancamento" label="Lançamento" :rules="fieldRules" disabled dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataLancamento" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataEmissao" label="Emissão" :rules="fieldRules" :disabled="baixa" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataEmissao" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataCompetencia" label="Competência" :rules="fieldRules" :disabled="baixa" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataCompetencia" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataVencimento" label="Vencimento" :rules="fieldRules" :disabled="baixa" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataVencimento" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataPagamento" label="Pagamento" :rules="baixa ? fieldRules : []" :disabled="!baixa" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataPagamento" no-title/>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-select v-model="item.formaPagamento" label="Forma Pagamento" :items="formaPagamentos" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.valor" label="Valor" :rules="fieldRules" step=".01" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.desconto" label="Desconto" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.juros" label="Juros" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.valorFinal" label="Valor Final" disabled dense outlined/> {{total}}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-textarea v-model="item.observacao" label="Observação" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.numeroDocumento" label="Número Documento" :disabled="baixa" :counter="20" maxlength="20" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.recorrencia" label="Recorrência (Meses)" :disabled="baixa || item.id != 0" dense outlined/>
                        </v-col>
                    </v-row>
                    <!-- <v-col v-if="baixa || item.situacao == 'P'" cols="12" md="12">
                        <v-chip v-if="item.nomeComprovante && item.situacao != 'P'" color="primary" close @click:close="ExcluirDocumento(item)">
                            {{item.nomeComprovante}}
                        </v-chip>
                        <v-chip v-if="item.nomeComprovante" color="primary">
                            {{item.nomeComprovante}}
                        </v-chip>
                        <v-file-input v-else show-size v-model="arquivoCarregar" label="Anexo" outlined dense/>
                    </v-col> -->
                    <v-col v-if="baixa" cols="12" md="12">
                        <v-file-input show-size v-model="arquivoCarregar" label="Anexo" outlined dense/>
                    </v-col>
                    <v-col v-if="item.situacao == 'P'" cols="12" md="12">
                        <v-chip v-if="item.nomeComprovante" color="primary">
                            <v-icon @click="DownloadArquivo(item)" class="mr-4">mdi-download</v-icon>
                            {{item.nomeComprovante}}
                        </v-chip>
                        <v-file-input v-else show-size v-model="arquivoCarregar" label="Anexo" outlined dense/>
                    </v-col>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import CompromissoService from '@/core/services/financeiro/CompromissoService';
import FormaPagamentoEnumService from '@/core/services/financeiro/FormaPagamentoEnumService';
import Compromisso from '@/core/domain/financeiro/Compromisso';
import BancoService from '@/core/services/financeiro/BancoService';
import PlanoContaService from '@/core/services/financeiro/PlanoContaService';
import FornecedorService from '@/core/services/financeiro/FornecedorService';
import ProjetoService from '@/core/services/projetos/ProjetoService';

export default {
    props:{
        item: {
            required: true
        },
        value: {},
        baixa: false
    },
    watch: { 
        item: function() { 
            if ('formCadastroCompromisso' in this.$refs)
                this.$refs.formCadastroCompromisso.resetValidation();

            if(this.item.projeto){
                this.projetos.push(this.item.projeto);
            }
            if(this.item.fornecedor){
                this.fornecedores.push(this.item.fornecedor);
            }
        },
        "item.planoContaId": function(){
            if (this.item.planoContaId > 0){
                let planoConta = this.planoContas.find(x => x.id == this.item.planoContaId);
                
                let resultado = planoConta.itens;

                this.planoContaItens = resultado.sort(function(a,b){
                    if(a.descricao > b.descricao){
                        return 1;
                    }
                    if(a.descricao < b.descricao){
                        return -1;
                    }
                    return 0;
                });

                if(!this.planoContaItens.find(x => x.id == this.item.planoContaItemId)){
                    this.item.planoContaItemId = null;
                }
            }
        },
        "item.projetoId": function(){
            if (this.item.projetoId > 0){
                let projeto = this.projetos.find(x => x.id === this.item.projetoId);

                this.atividades = projeto ? projeto.atividades : this.item.projeto.atividades;

                this.atividades = this.atividades.sort(function(a,b){
                    if(a.nome > b.nome){
                        return 1;
                    }
                    if(a.nome < b.nome){
                        return -1;
                    }
                    return 0;
                })
            } 
            else {
                this.item.atividadeId = null;
                this.atividades = [];
            }
        },
        "item.atividadeId": function(){
            if (this.item.atividadeId > 0){

                let atividade = this.atividades.find(x => x.id == this.item.atividadeId);

                if (!atividade){
                    atividade = this.item.projeto.atividades.find(x => x.id == this.item.atividadeId);
                }

                this.atividadeItens = atividade.itens;

                this.atividadeItens = this.atividadeItens.sort(function(a,b){
                    if(a.nome > b.nome){
                        return 1;
                    }
                    if(a.nome < b.nome){
                        return -1;
                    }
                    return 0;
                })

                if(!this.atividadeItens.find(x => x.id == this.item.atividadeItemId)){
                    this.item.atividadeItemId = null;
                }
            } 
            else {
                this.item.atividadeItemId = null;
                this.atividadeItens = [];
            }
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        },
        searchFornecedor (val) {
            if (this.isFornecedorLoading) return;
            if (!val) return;
            // if (val.length < 3 ) return;
            
            this.isFornecedorLoading = true
            let fornecedorService = new FornecedorService();
            fornecedorService.AutoComplete(val)
                .then(
                    res => {
                        this.fornecedores = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isFornecedorLoading = false))
        },
        searchProjeto (val) {
            if (this.item.projetoId) return;
            if (this.isProjetoLoading) return;
            if (!val) return;
            
            this.isProjetoLoading = true
            const projetoService = new ProjetoService();
            projetoService.AutoComplete(val)
                .then(
                    res => {
                        this.projetos = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isProjetoLoading = false))
        }
    },
    data: () => ({
        service: new CompromissoService(),
        valid: true,
        dialog: false,
        isFornecedorLoading: false,
        isProjetoLoading: false,
        formaPagamentos: [],
        bancos: [],
        planoContas: [],
        planoContaItens: [],
        atividades: [],
        atividadeItens: [],
        fornecedores: [],
        projetos: [],
        searchFornecedor: null,
        searchProjeto: null,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        arquivoCarregar: null,
        salvando: false
    }),
    methods: {
        save() {

            if (this.$refs.formCadastroCompromisso.validate()) {

                this.salvando = true;

                let modelo = new Compromisso(this.item);

                modelo.projeto = null;
                modelo.fornecedor = null;

                if (this.baixa){
                    this.service.Baixar(modelo).then(
                        res => {
                            if(this.arquivoCarregar){
                                this.EnviarDocumento(res.data.id ? res.data.id : this.item.id).then(() => {
                                    this.$emit('salvou');
                                    this.close();
                                });
                            }
                            else{
                                this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                                this.$emit('salvou');
                                this.close();
                            }
                        }, 
                        err =>  {
                            this.$swal('Aviso', err.response.data, err.response.status == 400 ? 'warning' : 'error');
                        }
                    ).finally(() => {
                        this.salvando = false;
                    });
                } 
                else {
                    this.service.Salvar(modelo).then(
                        res => {
                            this.$swal('Aviso', `Operação realizada com sucesso! - Código do compromisso ${res.data.id ? res.data.id : this.item.id}`, res.status == 201 || res.status == 200 ? 'success' : 'warning');
                            this.$emit('salvou');
                            this.close();
                        }, 
                        err =>  
                        {
                            this.$swal('Aviso', err.response.data, err.response.status == 400 ? 'warning' : 'error');
                        }
                    ).finally(() => {
                        this.salvando = false;
                    });
                }
            }

        },
        async EnviarDocumento(id){
        
            return new Promise(async (resolve, reject) => {

                let arquivo = await this.Ler(this.arquivoCarregar);

                this.service.EnviarDocumento(id, this.arquivoCarregar.name, arquivo).then(
                    res => resolve(res),
                    err => reject(err)
                )

            });
        },
        async Ler(arquivo) {
            return new Promise((resolve, reject) => {
            let fr = new FileReader();
        
            fr.onload = (arquivo) => {
                resolve(arquivo.target.result);
            };
        
            fr.readAsArrayBuffer(arquivo);
            });
        },
        DownloadArquivo(item){
            this.service.DownloadDocumento(item.id, item.nomeComprovante);
        },
        close() {
            this.arquivoCarregar = null;
            this.dialog = false;
            //Correção do Watch de Atividade e AtividadeItem
            this.item.atividadeId = 0;
            this.item.atividadeItemId = 0;
        },
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    computed:{
        total(){

            this.item.valorFinal = this.item.valor + this.item.juros - this.item.desconto;

        }
    },
    mounted() {

        let formaPagamentoEnumService = new FormaPagamentoEnumService();
        formaPagamentoEnumService.Listar()
            .then(
                res => {
                    this.formaPagamentos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        let planoContaService = new PlanoContaService();
        planoContaService.ListarByTipo('D', "Itens.PlanoContaContabil, Itens.PlanoContaContabilLivre, Itens.PlanoContaContabilRestrito")
            .then(
                res => {
                    let resultado = res.data.items;
                    this.planoContas = resultado.sort(function(a,b){
                        if(a.descricao > b.descricao){
                            return 1;
                        }
                        if(a.descricao < b.descricao){
                            return -1;
                        }
                        return 0;
                    })
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        new BancoService().Listar().then(
            res => {
                let resultado = res.data.items;

                this.bancos = resultado.sort(function(a,b){
                    if(a.nome > b.nome){
                        return 1;
                    }
                    if(a.nome < b.nome){
                        return -1;
                    }
                    return 0;
                }).filter(x => x.situacao == "A");
                
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        )
    }
}
</script>